import L from "leaflet";

export function addLayerPOO(map, points, options = {}) {

  const {
    minZoom = 12,
    maxZoom = 20,
    onSelect
  } = options;


  const layer = L.layerGroup();


  points.forEach((point) => {

    const lat = point.latitude;
    const lng = point.longitude;

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;


    const marker = L.marker([lat, lng], {
      icon: L.divIcon({
        className: "poo-label",
        html: `
          <div
            class="mapLabel"
            style="
              color:${point.color};
              font-size:${point.fontSize}px;
              font-weight:${point.fontWeight};
              font-style:${point.fontStyle};
              white-space: nowrap;
            "
          >
            ${point.name}
          </div>
        `,
      }),
    });


    if ((point.imageUrl || point.description) && onSelect) {
      marker.on("click", () => onSelect(point));
    }

    layer.addLayer(marker);

  });


  function updateVisibility() {
    const zoom = map.getZoom();

    if (zoom >= minZoom && zoom <= maxZoom) {
      if (!map.hasLayer(layer)) {
        layer.addTo(map);
      }
    } else {
      if (map.hasLayer(layer)) {
        map.removeLayer(layer);
      }
    }
  }


  map.on("zoomend", updateVisibility);

  updateVisibility();


  return layer;
}